import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeatureGrid from "./components/FeatureGrid";
import CTASection from "./components/CTASection";
import BlogSection from "./components/BlogSection";
import AboutSection from "./components/AboutSection";
import FAQSection from "./components/FAQSection";
import { useJsonLd, getSiteUrl } from "@/hooks/useJsonLd";
import { useEffect } from "react";

export default function Home() {
  const siteUrl = getSiteUrl();

  useEffect(() => {
    document.title = "Najlepszy Kakobuy Spreadsheet Polska 2026 | Kakobuy Spreadsheet";
  }, []);

  useJsonLd({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Kakobuy Spreadsheet Polska",
    "url": siteUrl,
    "description": "Najlepszy Kakobuy Spreadsheet dla polskich użytkowników — arkusz produktów z Chin z kategoriami Shoes, Hoodies, T-Shirts, Jackets i więcej.",
    "inLanguage": "pl",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${siteUrl}/?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  });

  useJsonLd({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Czy Kakobuy działa w Polsce?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Tak, Kakobuy obsługuje zamówienia do Polski z pełną obsługą wysyłki i śledzenia przesyłek.",
        },
      },
      {
        "@type": "Question",
        "name": "Jak długo trwa dostawa Kakobuy do Polski?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Standardowa dostawa do Polski trwa zazwyczaj od 10 do 20 dni roboczych, w zależności od wybranej metody wysyłki.",
        },
      },
      {
        "@type": "Question",
        "name": "Czy Kakobuy jest bezpieczny?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Kakobuy współpracuje ze sprawdzonymi sprzedawcami i oferuje ochronę płatności, co zapewnia bezpieczne zakupy.",
        },
      },
      {
        "@type": "Question",
        "name": "Jak znaleźć najlepszy Kakobuy Spreadsheet?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Najlepszy Kakobuy Spreadsheet znajdziesz na stronie kaspreadsheet.com, która zawiera linki do zweryfikowanych produktów we wszystkich kategoriach.",
        },
      },
      {
        "@type": "Question",
        "name": "Czy trzeba płacić cło przy zamówieniach z Kakobuy?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Przy wartości zamówienia powyżej 150 EUR mogą obowiązywać opłaty celne. Zaleca się sprawdzenie aktualnych przepisów celnych przed złożeniem zamówienia.",
        },
      },
      {
        "@type": "Question",
        "name": "Jakie metody płatności obsługuje Kakobuy?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Kakobuy obsługuje różne metody płatności, w tym karty kredytowe, PayPal oraz przelewy bankowe.",
        },
      },
    ],
  });

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeatureGrid />
        <CTASection />
        <BlogSection />
        <AboutSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}